import axios from 'axios';
import React, {useEffect, useState} from 'react';

import {FormCheckbox, FormDialog, MaskedNumber }from "../../../../controls";
import Validator from "../../validators/TripLegsActualWeightValidator";

const TripLegsActualWeightDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;

  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    record: {},
    title: 'Actual Payload',
  });
  useEffect(()=> {
    const open = async (params) => {
      const {record, title, canEdit} = params;
      setDialogState({...dialogState, showDialog:true, record: {...record, nilCargo: record.actualCargo === 0}, canEdit, title});
    }

    eventBus.bind("EditActualWeightDialog.open", open);

    return () => {
      eventBus.unbind("EditActualWeightDialog.open", open);
    }
  }, [dialogState, eventBus]);

  if (dialogState.showDialog) {
    return (
      <FormDialog
        title={dialogState.title}
        message="Please enter the actual payload for the flight"
        open={dialogState.showDialog}
        record={dialogState.record}
        dialogOptions={{maxWidth: "sm", fullWidth: false}}
        classes={classes}
        validator={Validator}
        buttons = {{
          save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{return status.error}}, 
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            axios.put(
              `${props.apiSitePrefix}/triplegs/updateActualCargo`, record
            ).then(saved => {
              setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
              if (props.afterSave) {
                props.afterSave();
              }
              if (typeof props.onClose === 'function') {props.onClose()}
            }).catch(error => {
              SystemData.openAlert("Error Saving Payload", "An unexpected error has occurred while saving the actual payload.");
            })
          } else {
            setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
            if (typeof props.onClose === 'function') {props.onClose()}
          }
        }}
      >
        <div style={{display: "inline-block", width: 120}} checkChildren={true}>
          {record => 
            <FormCheckbox
              id="nilCargo"
              label="NIL Cargo"
              checked={record.actualCargo === 0}
              onChange={(value, props)=> {
                const {recordChange, record} = props;
                recordChange({...record, nilCargo: value, actualCargo: value?0:null});
              }}
            />          
          }
        </div>
        <div style={{display: "inline-block", width: 120}} checkChildren={true}>
          {record => 
            <MaskedNumber
              label="Actual Payload"
              id="actualCargo"
              style={{ fontSize: "0.875rem", textAlign: "right" }}
              readOnly={!dialogState.canEdit || record.actualCargo === 0}
              disabled={record.actualCargo === 0}
              decimalScale={0}
              fixedDecimalScale={true}
              suffix=" kg"
              valueCap={300000}
            />
          }
        </div>
      </FormDialog>
    )
  }
  return (<></>);
}

export default TripLegsActualWeightDialog;